/**
 * @file default-object.form.tsx
 * @description Форма для создания и редактирования объектов по умолчанию в системе.
 * Включает поля для указания наименования и родительского элемента.
 * Поле родителя отображается только при наличии соответствующего значения.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @src/types, @components/form-controls/dictionary]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/dictionary/dictionary.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { BaseForm } from '@src/types';
import { Dictionary } from '@components/form-controls/dictionary';

export const Form = ({ control, getValues }: BaseForm) => {
    return (
        <div className="flex flex-col gap-default w-[37.5874vmin]">
            <TextField name="name" label="Наименование" control={control} />

            {getValues('parent') && <Dictionary label="Родитель" name="parent" control={control} />}
        </div>
    );
};
